import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { adminApi, errMsg } from "@/lib/api";
import { matchAreas } from "@/lib/areaSearch";
import { Btn } from "@/admin/ui";

export const NotifyWaitlistButton = ({ area, waitlist, onDone }) => {
  const waiting = waitlist.filter((w) => w.status === "waiting");
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);

  const show = () => {
    setSel(waiting.filter((w) => w.pincode === area.pincode || (!w.pincode && matchAreas([area], w.query).length)).map((w) => w.id));
    setOpen(true);
  };
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await adminApi.post(`/areas/${area.id}/notify-waitlist`, { ids: sel });
      data.sent ? toast.success(`WhatsApp sent to ${data.sent}`) : toast.error(`Not sent (${data.not_sent}). WhatsApp may not be configured yet.`);
      setOpen(false); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <button onClick={show} disabled={!waiting.length || !area.active} title="Notify waiting customers" className="p-1.5 text-stone-500 hover:text-primary disabled:opacity-30" data-testid={`area-notify-${area.pincode}`}>
        <BellRing className="w-4 h-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white sm:max-w-lg" data-testid={`notify-dialog-${area.pincode}`}>
          <DialogHeader>
            <DialogTitle>Notify waiting customers · {area.pincode}</DialogTitle>
            <DialogDescription>Matching searches are pre-ticked. Tick anyone else who lives in {area.name}.</DialogDescription>
          </DialogHeader>
          <div className="max-h-72 overflow-auto divide-y divide-stone-100">
            {waiting.map((w) => (
              <label key={w.id} className="flex items-center gap-3 py-2 text-sm cursor-pointer" data-testid={`notify-entry-${w.id}`}>
                <input type="checkbox" checked={sel.includes(w.id)} onChange={() => toggle(w.id)} className="accent-[#1A2E1C]" />
                <span className="font-semibold">{w.name}</span><span className="text-stone-500">+91 {w.phone}</span>
                <span className="ml-auto text-xs bg-stone-100 rounded px-2 py-0.5">{w.query}</span>
              </label>
            ))}
          </div>
          <Btn onClick={send} disabled={!sel.length || busy} data-testid="notify-send-btn">{busy ? "Sending…" : `Send WhatsApp to ${sel.length}`}</Btn>
        </DialogContent>
      </Dialog>
    </>
  );
};
